import { useEffect, useState, useContext } from "react";
import "rsuite/dist/rsuite.min.css";
import { useHistory } from "react-router-dom";
import Header from "../Components/Header";
import Menu from "../Components/Menu";
import FilterContext from "../Hooks/Context";
import {CONSTANTS} from '../Api/Constants';

const Layout = ( props ) => {
  const [menuStatus, SetMenuStatus] = useState(false);
  const [mapVisiblity, SetMapVisiblity] = useState(true);
  const [updateData, SetUpdateData] = useState();
  const [currentMenu, SetCurrentMenu] = useState();
  const [menuUpdate, SetMenuUpdate] = useState(false);

  const filterQueries = useContext(FilterContext);
  const history = useHistory();

  useEffect(() => {
    let date = new Date();
    let startOfDay = Math.floor(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        CONSTANTS.SHIFT.STARTHOUR,
        CONSTANTS.SHIFT.STARTMIN,
        CONSTANTS.SHIFT.STARTSEC
      ) / 1000
    );
    let endOfDay = Math.floor(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1,
        CONSTANTS.SHIFT.ENDHOUR,
        CONSTANTS.SHIFT.ENDMIN,
        CONSTANTS.SHIFT.ENDSEC
      ) / 1000
    );

    let filterRequestQuery = {
      factory: "2",
      lines: "2",
      shift: "",
      startTs: startOfDay,
      endTs: endOfDay,
      ...filterQueries.filterRequestQuery
    };

    filterQueries.GenerateFilters(filterRequestQuery);
  }, []);

  useEffect(() => {
    SetUpdateData(!updateData);
  }, [filterQueries]);

  const ToggleClass = () => {
    SetMenuStatus(!menuStatus);
  };

  const SetSelectedMenu = (menuName) => {
    SetCurrentMenu(menuName);
    localStorage.setItem('currentMenu', menuName);
    SetMenuUpdate(!menuUpdate);
  }

  return (
    <>
      <div className="container-fluid white-bg content-area">
        {filterQueries.ChangeLanguage && (
          <Header
            onLanguageChange={filterQueries.ChangeLanguage}
            ToggleClass={ToggleClass}
          />
        )}

        <div className={`row ${menuStatus ? "menuOpen" : ""}`}>
          <div className="col-md-3 col-sm-12 menu-container">
            <Menu key={ menuUpdate } />
          </div>
          <div className="col-md-9 col-sm-12 map-container">
            { props.children }
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
